import { useFormContext } from 'react-hook-form';

import { useLoanTokens } from '@/hooks/query/loans/useLoanTokens';
import { cn } from '@/utils/helper';
import { IDesiredTerms } from 'types/loan';

interface PotentialProfitProps {
  className?: string;
}

function PotentialProfit({ className }: PotentialProfitProps) {
  const { watch } = useFormContext<IDesiredTerms>();

  const interestRate = watch('interestRate');
  const currency = watch('currency');

  const { data } = useLoanTokens();

  const symbol = data?.find((token) => token.address === currency)?.symbol;

  return (
    <div className={cn('text-sm text-coal-250', className)}>
      Potential Profit:{' '}
      <span className='font-semibold'>
        {interestRate.toFixed(3)} {symbol}
      </span>
    </div>
  );
}

export default PotentialProfit;
